"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgNode(_a) {
    var { nodeData } = _a, props = __rest(_a, ["nodeData"]);
    if (!nodeData) {
        return null;
    }
    return react_1.default.createElement(nodeData.name, Object.assign(Object.assign({}, props), { d: nodeData.d }), (nodeData.children || []).map((child, i) => {
        return react_1.default.createElement(SvgNode, { key: i, nodeData: child });
    }));
}
exports.default = SvgNode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3ZnTm9kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1N2Z05vZGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxrREFBMEI7QUFPMUIsU0FBd0IsT0FBTyxDQUFDLEVBQW9DO1FBQXBDLEVBQUUsUUFBUSxPQUEwQixFQUFyQixLQUFLLGNBQXBCLFlBQXNCLENBQUY7SUFDbEQsSUFBSSxDQUFDLFFBQVEsRUFBRTtRQUNiLE9BQU8sSUFBSSxDQUFDO0tBQ2I7SUFFRCxPQUFPLGVBQUssQ0FBQyxhQUFhLENBQ3hCLFFBQVEsQ0FBQyxJQUFJLGtDQUNSLEtBQUssS0FBRSxDQUFDLEVBQUUsUUFBUSxDQUFDLENBQUMsS0FDekIsQ0FBQyxRQUFRLENBQUMsUUFBUSxJQUFJLEVBQUUsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUN6QyxPQUFPLDhCQUFDLE9BQU8sSUFBQyxHQUFHLEVBQUUsQ0FBQyxFQUFFLFFBQVEsRUFBRSxLQUFLLEdBQUksQ0FBQztJQUM5QyxDQUFDLENBQUMsQ0FDSCxDQUFDO0FBQ0osQ0FBQztBQVpELDBCQVlDIn0=